import { $sxhr } from "../../stempcore";
import { sxhr } from "fire-wind-water/sxhr";
import { from, of } from "rxjs";
import { mergeMap } from "rxjs/operators";

const cacheWithParams = {
  _cache_with_cached: 0,
  _cache_refresh: 0,
  _cache_timeout: 5 * 60
};

// 封装静态化请求
const staticRequest = function(url, info, conf) {
  // 存在静态化配置，优先获取静态连接，如不存在，走API请求
  var staticUrl = window.staticReqMapping
    ? window.staticReqMapping.getStaticUrl(url, info)
    : "";
  // console.log('########################################');
  // console.log(url, staticUrl);
  const params = { ...info, ...cacheWithParams };
  if (staticUrl) {
    return from(
      // 利用from操作符将Promise转为Observable
      // 请求静态地址(url上需要添加随机数，以保证数据为最新)
      sxhr
        .get(staticUrl + "?time_stamp=" + new Date().getTime(), info, conf)
        .then(
          res => {
            return res.data.body;
          },
          () => {
            return null; // 静态json错误，返回null
          }
        )
    ).pipe(
      mergeMap(body => {
        if (body) {
          return of(body);
        } else {
          // 静态json出错，转为API请求
          return $sxhr.post(url, params, conf);
        }
      })
    );
  } else {
    return $sxhr.post(url, params, conf);
  }
};

export default {
  install: function(Vue) {
    Vue.prototype.service = {
      getTemplateConfig: info => {
        return $sxhr.post("template/platform/instance/getConfig", info);
      },
      getReleaseFile: info => {
        return $sxhr.post("file/folder/getReleaseFile", info);
      },
      getReleaseFileList: info => {
        return $sxhr.post("file/folder/getReleaseFileList", info);
      },
      interactionPreview: info => {
        return window.$sk.$skxhr("api/file/interaction/preview", info);
      },
      interactionBrowse: info => {
        return window.$sk.$skxhr("api/file/interaction/browse", info);
      },
      downloadWithEmail: info => {
        return $sxhr.post("file/downloadWithEmail", info);
      },
      getContact: info => {
        return $sxhr.post("api/wechat/contacts/get", info);
      },
      getDomain: info => {
        return $sxhr.post("api/domain/GetDomain", info);
      },
      getWatermark: info => {
        return $sxhr.post("api/file/watermark/get", info);
      },
      recordDownload: info => {
        return $sxhr.post("api/file/download/personal", info);
      },
    };
  }
};
export { staticRequest };
